import { servicedeskKnowledgeBaseServerLinkStatusResource } from '@jira/router-resources__service-desk-knowledge-base/src/servicedeskKnowledgeBaseServerLinkStatusResource.tsx';
import { servicedeskKnowledgeBaseLinkedSourcesResource } from '@jira/router-resources__service-desk-knowledge-base/src/servicedeskKnowledgeBaseLinkedSourcesResource.tsx';
import { servicedeskKnowledgeBaseThirdpartyConnectorsResource } from '@jira/router-resources__service-desk-knowledge-base/src/servicedeskKnowledgeBaseThirdpartyConnectorsResource.tsx';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import {
	getServicedeskPageContextResources,
	getServiceDeskSettingsResources,
} from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { projectSettingsServicedeskKbRoute } from '@jira/router-routes__project-settings-service-desk-knowledge-base-routes/src/projectSettingsServicedeskKbRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { getKBExperimentResources } from '@jira/router-routes__servicedesk-knowledge-hub-entries/src/common/getKBExperimentResources.tsx';
import type { Route } from '@atlassian/react-resource-router';
import {
	ServiceDeskKnowledgeBaseV2,
	LazyProjectSettingsServiceDeskKnowledgeBaseV2,
} from './ui/service-desk-knowledge-base/index.tsx';

export const projectSettingsServicedeskKbRouteEntry: Route = createEntry(
	projectSettingsServicedeskKbRoute,
	() => ({
		group: 'project-settings-servicedesk',
		perfMetricKey: 'service-management.kb-settings',
		layout: serviceProjectLayout,
		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},
		// eslint-disable-next-line no-restricted-syntax
		component: ServiceDeskKnowledgeBaseV2,
		forPaint: [LazyAtlassianNavigation, LazyProjectSettingsServiceDeskKnowledgeBaseV2],
		resources: [
			...getServiceDeskSettingsResources(),
			...getServicedeskPageContextResources(),
			getConsolidationStateResource(),
			...getKBExperimentResources(),
			servicedeskKnowledgeBaseThirdpartyConnectorsResource,
			servicedeskKnowledgeBaseServerLinkStatusResource,
			servicedeskKnowledgeBaseLinkedSourcesResource,
		],
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
